<template>

   
<ui-button-options v-on:click.native.stop="addAbsence()" :title="getTitle(item)" subtitle="" backgroundColor="rgba(252,252,252)">
      <div slot="left"><ui-icon :color="getColor(item)" backgroundColor="transparent" class="email-icon" icon="user"></ui-icon></div>

      
     
      <div slot="options" v-if="computeUserAccess">
       
       <ui-option  title="language.add" v-on:click.native.stop.prevent="addAbsence()" backgroundColor="#F2BC55" color="#FFFFFF" icon="pencil-alt"/>
    
      </div>
    
   </ui-button-options>
</template>

<script>
import UiButtonOptions from '../UiButtonOptions.vue';
import UiOption from '../UiOption.vue';
import UiIcon from '../UiIcon.vue';
import { USER_LEVEL } from '../../settings/USER_LEVEL.js';
import { mapState } from 'vuex';
import { helper } from '../../services/Helper.js';
      
    
export default {
  name: 'button-chils',
  props:{
    item:{default:{id:0}},
    download_id:{default:0},
  },
  data:function(){
    return {
      group_id:this.$route.params.id
    }
  },
  computed:{
    ...mapState([
       'appSettings','group'
      ]),
    computeUserAccess(){
      
        //var isInGlobal=(this.$router.currentRoute.path=='/documents');
        //if(!this.group.authorized && !isInGlobal ){
          // if we are in a group
         //  return false;
         //}
          // ONLY A PARENT CAN ADD AN ABSENCE FOR A CHILD
         if (this.appSettings.user_level==USER_LEVEL.NONE){
           return false;
         }
         if (this.appSettings.user_level==USER_LEVEL.PARENT){
           return true;
         }
         if (this.appSettings.user_level==USER_LEVEL.TEACHER){
           return true;
         }
         if (this.appSettings.user_level==USER_LEVEL.STUDENT){
           return false;
         }
         if (this.appSettings.user_level==USER_LEVEL.ADMIN){
           return true;
         }
         return false;
        
    }
  },
  methods:{
    getTitle(item){
      var title=item.name;
      //if(item.absence){
      //  title+=" - "+item.reason;
      //}
      
      return helper.decodeHtml(title);
    },
    getColor(item){
      if(!item.absence){
        return "#B4B4B4";
      }else{
        return "#FF0000";
      }
    },
    createSubtitle(item){
      if(item.absence){
        return item.date+' : '+this.createIntroText(item.description)
      }
      return undefined;
      
    },
    createIntroText(txt){
         return helper.getExcerpt(txt);
    },
    addAbsence(){
     
      // parents and teachers can call in sick..
      if (this.appSettings.user_level!==USER_LEVEL.STUDENT ){
        // we need the parent_id if we want to call in sick on behalf of a parent when we are teacher..
        this.$router.push({path:'/group/add_absence/'+this.group_id+'/'+this.item.parent_id+'/'+encodeURIComponent(this.item.name)})
      }
      
    /*
    if(this.item.absence){
      // already absent, just go to view
      this.$router.push({path:'/group/'+this.group_id+'/absence/view/'+this.item.id})
    }else{
      // add absence
      
    }
  */
   
     
    },
    
    formatDate(date){
      var year=date.getFullYear();
      var month=(date.getMonth()+101).toString().slice(-2);
      var day=(date.getDate()+100).toString().slice(-2);
      // set date?
      return year+"-"+month+"-"+day;

    },
    /*
    edit_absence(id){
     this.$router.push({path:'/group/'+this.group_id+'/absence/update/'+id})
    },
    delete_absence(id){
      // child is better
      var today=new Date();
      var date= this.formatDate(today)

      var payload={
          store_key:this.group_id+"absences",
          id:id,
          date:date,
        }

        this.$store.dispatch('delete_absence',payload).then(
          ()=>{
            //console.log(result)
            //this.back();
          }
        )
      },
    */
    
  },
  mounted:function(){
    
  },
  components:{
    UiButtonOptions,
    UiOption,
    UiIcon,
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.img-icon{
  display:block;
  height: 50px;
  width: 50px;
  border-radius: 9999px;
  border: 1px solid #707070;
}
</style>
